import * as Yup from 'yup';
import { Icon } from '@iconify/react';
import { Box, Button, Dialog, IconButton, Stack, TextField, Typography } from '@mui/material';
import React from 'react';
import { dispatch } from '../../redux/store';
import { saveNewsletters } from '../../redux/slices/newsletters';
import { useSnackbar } from 'notistack';

const validationEmail = Yup.object().shape({
  email: Yup.string().email('Entrez une adresse e-mail valide').required("L'adresse e-mail est requise"),
});

export default function NewsLetterModal({ open, onClose }) {
  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [error, setError] = React.useState(null);
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = (event) => {
    event.preventDefault();
    validationEmail
      .validate({ email })
      .then(() => {
        dispatch(
          saveNewsletters(
            { email, name },
            () => {
              enqueueSnackbar('Votre inscription à la newsletter est confirmée', { variant: 'success' });
            },
            (saveError) => {
              if (saveError?.status === 409) {
                enqueueSnackbar('Vous êtes déjà inscrit à notre newsletter', { variant: 'warning' });
              } else {
                enqueueSnackbar("Une erreur s'est produite", { variant: 'error' });
              }
            }
          )
        );
        onClose();
      })
      .catch((err) => setError(err.errors?.at(0)));
  };

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          maxWidth: 520,
          borderRadius: '0 !important',
          overflow: 'hidden',
          boxShadow: '0 20px 60px rgba(20, 45, 38, 0.22)',
        },
      }}
    >
      <Box
        component="form"
        onSubmit={handleSubmit}
        noValidate
        sx={{ '& .MuiOutlinedInput-root, & .MuiButton-root, & .MuiIconButton-root': { borderRadius: 0 } }}
      >
        <Stack direction="row" justifyContent="flex-end" sx={{ px: 1.5, pt: 1.5 }}>
          <IconButton type="button" onClick={onClose} aria-label="Fermer">
            <Icon icon="eva:close-fill" height={24} width={24} />
          </IconButton>
        </Stack>

        <Stack spacing={3} sx={{ px: { xs: 2.5, sm: 4 }, pb: { xs: 3, sm: 4 } }}>
          <Box>
            <Typography variant="h4" sx={{ mb: 1.5 }}>
              Abonnez-vous à notre newsletter
            </Typography>
            <Typography color="text.secondary" sx={{ lineHeight: 1.6 }}>
              Recevez les actualités de lʼAPI-ZF par e-mail.
            </Typography>
          </Box>

          <TextField
            fullWidth
            label="Nom et prénoms"
            value={name}
            autoComplete="name"
            onChange={(event) => setName(event.currentTarget.value)}
            InputProps={{ sx: { borderRadius: 0 } }}
          />

          <TextField
            fullWidth
            required
            type="email"
            label="Adresse e-mail"
            value={email}
            autoComplete="email"
            error={Boolean(error)}
            helperText={error || ' '}
            onChange={(event) => {
              setEmail(event.currentTarget.value);
              if (error) setError(null);
            }}
            InputProps={{ sx: { borderRadius: 0 } }}
          />

          <Button
            fullWidth
            type="submit"
            color="primary"
            variant="contained"
            endIcon={<Icon icon="eva:arrow-forward-fill" height={20} width={20} />}
            sx={{ minHeight: 48, borderRadius: 0, fontWeight: 700 }}
          >
            Je mʼabonne
          </Button>
        </Stack>
      </Box>
    </Dialog>
  );
}
